import TripsLayout from "./TripsLayout";
import TripsMap from "./TripsMap";
import MyAccount from "./MyAccount";

import AlertsRegistration from "./AlertsRegistration";
import AlertsLogin from "./AlertsLogin";
import PasswordReset from "./PasswordReset";
import VerifyAlertsRegistration from "./VerifyAlertsRegistration";
import ResetPassword from "./ResetPassword";

const module = {
  routeProps: {
    path: "/Routes",
    component: TripsLayout,
  },
  name: "My Routes",
  label: "My Routes",
  error: "No Page Selected",
  submodules: [
    TripsMap,
    MyAccount,
    AlertsRegistration,
    AlertsLogin,
    PasswordReset,
    VerifyAlertsRegistration,
    ResetPassword,
  ],
  showOnHeader: true,
  defaultOpen: false,
};

export default module;
